// extracted by mini-css-extract-plugin
export var chevron = "_jc-3";
export var chevronRotated = "_jc-4";
export var image = "_jc-1";
export var imageContainer = "_jc-0";
export var shippingAddress = "_jc-2";